export default "__VITE_ASSET__PaYlOatJ__"